import * as React from "react";

export const Table = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.4999 2.4C2.3401 2.4 1.3999 3.3402 1.3999 4.5V11.5C1.3999 12.6598 2.3401 13.6 3.4999 13.6L5.9999 13.6H9.9999L12.4999 13.6C13.6597 13.6 14.5999 12.6598 14.5999 11.5V6V4.5C14.5999 3.3402 13.6597 2.4 12.4999 2.4H3.4999ZM10.5999 12.4H12.4999C12.997 12.4 13.3999 11.9971 13.3999 11.5V6.6H10.5999V12.4ZM9.3999 6.6V12.4H6.5999V6.6H9.3999ZM9.9999 5.4H13.3999V4.5C13.3999 4.00295 12.997 3.6 12.4999 3.6H3.4999C3.00285 3.6 2.5999 4.00295 2.5999 4.5V5.4H5.9999H9.9999ZM2.5999 6.6H5.3999V12.4H3.4999C3.00285 12.4 2.5999 11.9971 2.5999 11.5V6.6Z"
    />
);
